import React, { FC, Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { withTranslation, WithTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';

import StoreModel from 'models/Index';
import { Services } from 'helpers/constants/Services';
import { withRouter, RouteComponentProps } from 'react-router';
import { ThemeType } from 'interfaces';

interface HeaderProps extends RouteComponentProps<any>, WithTranslation { }
interface HeaderPropsInjected extends HeaderProps {
    Store: StoreModel;
}

const useStyles = makeStyles({
    container: {
        width: '50%',
        display: 'flex',
        backgroundColor: (theme: ThemeType) => theme.header.backgroundColor,
        alignItems: 'center',
        padding: ' calc(15vh / 100 * 5) calc(15vh / 100 * 5) calc(15vh / 100 *5 ) 10%',
    },
    containerRight: {
        width: '50%',
        display: 'flex',
        backgroundColor: (theme: ThemeType) => theme.header.backgroundColor,
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'flex-end',
        padding: 'calc(15vh / 100 * 5) 10% calc(15vh / 100 * 5) calc(15vh / 100 *5 )',
    },
    defaultLogo: {
        maxHeight: 'calc(15vh - 8px - (15vh / 100 * 5) - (15vh / 100 * 5))',
        maxWidth:'50%'
    },
    suddenLinkLogo: {
        maxHeight: 'calc(15vh - 8px - (15vh / 100 * 5) - (15vh / 100 * 5))',
        maxWidth:'50%'
    },
    optimumLogo: {
        maxHeight: 'calc(15vh - 8px - (15vh / 100 * 5) - (15vh / 100 * 5))',
        maxWidth:'50%'
    },
    title: {
        fontSize: '2.5rem',
        fontFamily: 'Montserrat',
        color: (theme: ThemeType) => theme.header.fontColor,
    },
});

const Header: FC<HeaderPropsInjected> = (props) => {
    const injected = props as HeaderPropsInjected;

    const { t } = props;
    const { Store } = injected;

    const classes = useStyles(Store.deviceProfile.theme);

    const logoClasses = {
        [classes.defaultLogo]: !Store.isSuddenLink && !Store.isOptimum,
        [classes.suddenLinkLogo]: Store.isSuddenLink,
        [classes.optimumLogo]: Store.isOptimum,
    };
    const logoUrl = Store.kioskLogo;

    return (
        <Fragment>
            <Box className={classes.container}>
                <img
                    className={classNames(logoClasses)}
                    src={logoUrl}
                    alt={'logo'}
                />
            </Box>
            {/* <div style='height: 100px; width: 300px; background-color: green'>
                    <img
                        style='height: 100%; width: 100%; object-fit: contain'
                        src='http://www.sherkspear.com/wp-content/uploads/2015/04/jsfiddle.png'
                    />
                </div> */}

            <Box className={classes.containerRight}>
                <Typography variant='h5' className={classes.title}>
                    {t('Express Pay')}
                </Typography>
            </Box>
        </Fragment>
    );
};

export default withTranslation()(
    withRouter(inject(Services.STORE)(observer(Header)))
);
